<template>
    <!-- 对话框 -->
    <el-dialog title="司机钱包提现审核" :visible.sync="show" :before-close="closeDialog" style="width: 60%; margin: 0 auto">
        <!-- 基本信息表单 -->
        <div class="form-box">
            <el-form label-width="80px">
                <el-form-item label="司机名称:" label-width="120px">
                    {{ tableData.driver.name }}
                </el-form-item>

                <el-form-item label="银行卡号:" label-width="120px">
                    {{ tableData.driver_bank_card.bank_card_no }}
                </el-form-item>

                <el-form-item label="开户行:" label-width="120px">
                    {{ tableData.driver_bank_card.address }}
                </el-form-item>

                <el-form-item label="提现金额:" label-width="120px">
                    {{ tableData.amount }}
                </el-form-item>

                <el-form-item label="审核判定:" label-width="120px">
                    <el-radio-group v-model="submit_data.status">
                        <el-radio-button label="0">待审</el-radio-button>
                        <el-radio-button label="1">通过</el-radio-button>
                        <el-radio-button label="2">驳回</el-radio-button>
                    </el-radio-group>
                </el-form-item>

                <el-form-item label="审核备注:" label-width="120px">
                    <el-input type="textarea" autosize v-model="submit_data.remarks" :placeholder="submit_rules.remarks.placeholder">
                    </el-input>
                </el-form-item>
            </el-form>

            <!-- 对话框底部按钮 -->
            <div style="display: flex; justify-content: center">
                <submitBtn
                    @onSubmitDig="onSubmitDig"
                    :data="submit_data"
                    :rules="submit_rules"
                    url="/driver/executeDriverCashSubmit"
                    :JSON_Boolean="false"
                ></submitBtn>
                <el-button @click="closeDialog">关闭</el-button>
            </div>
        </div>
    </el-dialog>
</template>

<script>
var _this;
export default {
    props: {
        isShow: Boolean,
        data: ''
    },
    watch: {
        isShow(newData, oldData) {
            _this.show = true;

            _this
                .$post('/driver/getDriverCashDetails', {
                    driver_cash_code: _this.data
                })
                .then((res) => {
                    _this.tableData = res.data;
                    _this.submit_data.driver_cash_code = res.data.driver_cash_code;
                    _this.submit_data.status = res.data.status.val;
                    _this.submit_data.remarks = res.data.remarks;
                    _this.status_arrway = res.data.status.select_array;
                })
                .catch((err) => {});
        }
    },
    data() {
        return {
            show: false,
            status_arrway: [],

            tableData: [],

            // 表单数据
            submit_data: {
                driver_cash_code: '',
                status: '',
                remarks: ''
            },

            submit_rules: {
                driver_cash_code: {
                    placeholder: '唯一编码',
                    rules: {
                        required: true,
                        message: '唯一编码错误',
                        regulation: 'gt_str',
                        rulesData: 0
                    }
                },
                status: {
                    placeholder: '审核状态',
                    rules: {
                        required: true,
                        message: '审核状态错误',
                        regulation: 'egt_str',
                        rulesData: 1
                    }
                },
                remarks: {
                    placeholder: '请输入审核备注',
                    rules: {
                        required: true,
                        message: '审核备注最少4字以上',
                        regulation: 'egt_str',
                        rulesData: 4
                    }
                }
            }
        };
    },
    created() {
        _this = this;
    },
    methods: {
        // 关闭方法
        closeDialog() {
            _this.show = false;

            for (const key in _this.submit_data) {
                _this.submit_data[key] = '';
            }
        },

        // 提交
        onSubmitDig() {
            // 向父组件通讯刷新表格内容
            _this.$emit('onSubmit');
            // 关闭对话框
            _this.closeDialog();
        }
    }
};
</script>

<style scoped>
.form-box {
    padding: 20px;
    box-sizing: border-box;
    margin-right: 0;
    width: 100%;
}
</style>
